module.exports = __webpack_public_path__ + "static/media/Group-8243.cfdaaece.svg";